import {isNotNil} from 'ramda-adjunct';

import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {
  allocateDashboardGrid,
  compareDashboardGridPositions,
  dashboardGridTilesOverlap,
  isDashboardGridPositionValid,
  PositionedDashboardGridTile,
} from './allocateDashboardGrid';

const toPositionedTile = (tile: DashboardTilePlacement): PositionedDashboardGridTile | null =>
  isNotNil(tile.column) && isNotNil(tile.row)
    ? {id: tile.id, size: tile.size, column: tile.column, row: tile.row}
    : null;

export function reconcileDashboardGrid(
  tiles: DashboardTilePlacement[]
): PositionedDashboardGridTile[] {
  const fixed: PositionedDashboardGridTile[] = [];
  const queued = tiles.filter((tile) => {
    const positioned = toPositionedTile(tile);

    if (
      positioned === null ||
      !isDashboardGridPositionValid(positioned) ||
      fixed.some((candidate) => dashboardGridTilesOverlap(positioned, candidate))
    ) {
      return true;
    }

    fixed.push(positioned);

    return false;
  });
  const allocated = allocateDashboardGrid(queued, {occupied: fixed});

  if (allocated !== null) {
    return [...fixed, ...allocated].sort(compareDashboardGridPositions);
  }

  const compacted = allocateDashboardGrid(tiles.map(({id, size}) => ({id, size})));

  if (compacted === null) {
    throw new RangeError('Dashboard grid capacity exceeded');
  }

  return compacted.sort(compareDashboardGridPositions);
}
